import { ref } from 'vue';
import useSessionStore from '@/Stores/useSessionStore';
import useLocalStreamingDevicesStore from '@/Stores/useLocalStreamingDevicesStore';
import { DISPLAY_NAME } from '@/Utils/vice-constants';

function useJitsiTracksComposable(
  props,
  { myJitsiId, jitsiRoom, videoAudioRefs, internalCameraUser },
) {
  const isJoined = ref(null);
  const sessionStore = useSessionStore();
  const multiCameraDevicesStore = useLocalStreamingDevicesStore();

  const resetMicState = async (shouldTurnOnMic) => {
    await multiCameraDevicesStore.resetMicState(shouldTurnOnMic);
  };

  // Does not have permission error and conference has been joined already
  // This handles a situation where there was a media permission which was allowed later

  // We don't allow a user to join the conference or view others if they don't grant permission to
  // camera and microphone

  // When they grant it later, we add them to the room if they are not part
  const setVideoAudioRefs = (el, id) => {
    if (!videoAudioRefs[id]) {
      videoAudioRefs[id] = [];
    }
    if (el) {
      videoAudioRefs[id].push(el);
    }
  };

  const initializeRoom = () => {
    // Initialize the room only when participant has permission and has tracks.
    // Observer can join without tracks
    // TODO: Maybe this condition is redundant since we call initializeRoom after this is already checked in ConsultationVideoCall and GroupCallView
    if (internalCameraUser.value?.localTracks || sessionStore.userIsObserver) {
      // jitsiRoom.value?.setReceiverVideoConstraint(720); // temporal deactivation
      if (sessionStore.userIsObserver) {
        jitsiRoom.value?.setDisplayName(DISPLAY_NAME.OBSERVER);
      } else {
        jitsiRoom.value?.setDisplayName(
          `${sessionStore.authUser?.name}-${sessionStore.authUser.id}`,
        );
      }
      const profilePhoto = sessionStore.authUser.profile_photo_url
        ? sessionStore.authUser.static_avatar_url
        : null;
      jitsiRoom.value?.setLocalParticipantProperty('avatar', profilePhoto);
      jitsiRoom.value?.setLocalParticipantProperty('isClinician', sessionStore.isClinician);
      jitsiRoom.value?.join();
      myJitsiId.value = jitsiRoom.value?.myUserId();
    }
  };

  return {
    resetMicState,
    initializeRoom,
    isJoined,
    setVideoAudioRefs,
  };
}

export default useJitsiTracksComposable;
